var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarSpecialUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 28,
    rx: 10,
    fill: "#FFCACA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9718 4.70846C15.4382 3.93348 16.5618 3.93348 17.0282 4.70847L19.3586 8.58087C19.5262 8.85928 19.7995 9.05784 20.116 9.13116L24.5191 10.1509C25.4002 10.355 25.7474 11.4236 25.1545 12.1066L22.1918 15.5196C21.9788 15.765 21.8744 16.0863 21.9025 16.41L22.2932 20.9127C22.3714 21.8138 21.4625 22.4742 20.6296 22.1214L16.4681 20.3583C16.1689 20.2316 15.8311 20.2316 15.5319 20.3583L11.3704 22.1214C10.5375 22.4742 9.62856 21.8138 9.70677 20.9127L10.0975 16.41C10.1256 16.0863 10.0212 15.765 9.80823 15.5196L6.8455 12.1066C6.25257 11.4236 6.59977 10.355 7.48095 10.1509L11.884 9.13116C12.2005 9.05784 12.4738 8.85928 12.6414 8.58087L14.9718 4.70846Z",
    fill: "#2A2A2B",
    stroke: "#2A2A2B",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSpecialUser);
export default __webpack_public_path__ + "static/media/StarSpecialUser.8123e83122a0252a224f8862e8b13add.svg";
export { ForwardRef as ReactComponent };